<template>
<div id="topLeft1">
    <div class="bg-color-black">
        <div class="cc-header">
            <div>各学校总金额</div>
        </div>
        <div class="d-flex jc-center">
            <div id="barChart" class="barChart"></div>
        </div>
    </div>
</div>
</template>

<script>
const echarts = require("echarts");
let pageSize = 8; //echarts每页显示数量
export default {
    data() {
        return {
            start: 0,
            end: pageSize - 1,
            total: 0
        };
    },
    mounted() {
        this.initData();
        // 定时器刷新，1分钟
        let _this = this;
        setInterval(() => {
            _this.initData();
        }, 1000 * 60);
        // 定时器轮播，5秒
        setInterval(() => {
            _this.dataZoomAutoScoll();
        }, 1000 * 5);
    },
    methods: {
        //echarts图标数据过多时，x轴自动滑动
        dataZoomAutoScoll() {
            let myChart = echarts.init(document.getElementById("barChart"));
            const max = this.total - 1;
            if (pageSize < this.total) {
                if (this.end > max || this.start > max - pageSize) {
                    this.start = 0;
                    this.end = pageSize - 1;
                } else {
                    this.start += 1;
                    this.end += 1;
                }
                myChart.dispatchAction({
                    type: 'dataZoom',
                    dataZoomIndex: 0,
                    startValue: this.start,
                    endValue: this.end
                });
            }
        },
        initData() {
            let _this = this;
            let myChart = echarts.init(document.getElementById("barChart"));
            this.$http.get("/dataView/pay/getTotalMoneyByOrg").then(res => {
                if (res.data.code === 200) {
                    var result = res.data.result;
                    _this.total = result.xDatas.length;
                    var option = {
                        color: ['#2d0eab'],
                        dataZoom: [{
                            type: 'inside',
                            startValue: _this.start,
                            endValue: _this.end,
                        }],
                        grid:{
                            y:20,//解决Y轴手机端坐标显示不全
                            height:"50%",
                        },
                        xAxis: [{
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: '#d8d8d8'
                                }
                            },
                            axisLabel: {
                                interval: 0,
                                rotate: -25, // 角度
                                formatter: function (value) {
                                    return (value.length > 6 ? (value.slice(0, 6) + "...") : value)
                                },
                                textStyle: {
                                     fontSize: fontSize(0.15)
                                }
                            },
                            data: result.xDatas
                        }],
                        yAxis: [{
                            type: 'value',
                            name: '',
                            nameTextStyle: {
                                padding: [20, 0, 10, -20],
                                fontSize: fontSize(0.15)
                            },
                            axisLine: {
                                lineStyle: {
                                    color: '#d8d8d8'
                                }
                            },
                            axisLabel: {
                                textStyle: {
                                    fontSize: fontSize(0.15)
                                }
                            },
                            splitLine: {
                                show: false
                            },
                        }],
                        series: [{
                            data: result.yDatas,
                            type: 'bar',
                            barWidth: 15,
                            itemStyle: {
                                normal: {
                                    barBorderRadius: 7,
                                    label: {
                                        show: true,
                                        position: 'top',
                                        textStyle: {
                                            color: '#FF9800',
                                            fontSize: fontSize(0.15)
                                        }
                                    }
                                }
                            }
                        }]
                    };
                }
                myChart.hideLoading(); //没有加载出来隐藏加载动画
                myChart.setOption(option);

                // 响应式变化
                window.addEventListener("resize", () => myChart.resize(), false);
            });
        }
    },
    destroyed() {
        window.onresize = null;
    }
};
function fontSize(res){
    let clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
    if (!clientWidth) return;
    let fontSize = 100 * (clientWidth / 1920);
    return res*fontSize;
}
</script>

<style lang="scss">
#topLeft1 {
    height: 30vh;

    .cc-header {
        height: 0.5rem;
        padding-top: 0.5rem;
        color: #fff;
        font-size: 0.3rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .barChart {
        width: 7rem;
        height: 3.5rem;
		margin-top: 0.4rem;
    }
}
</style>
